module.exports = __webpack_public_path__ + "img/prize_message.a4124be2.svg";